export default "https://assets.pclncdn.com/web/next-landing/aa244f7d83/_next/static/images/seattle-8eca3cecfdd01c3714d6763ac281e840.webp";